import type React from 'react';
import Box from '@mui/material/Box';
import { SectionToolbarAddMenu } from './SectionToolbarAddMenu';
import { useEffectiveOrientation } from 'hooks/useEffectiveOrientation';
import { getCanvasWidth } from '../shared/gridConfig';

interface SectionsBottomToolbarProps {
  sectionId: string;
}
export function SectionsBottomToolbar({ sectionId }: SectionsBottomToolbarProps) {
  const orientation = useEffectiveOrientation();
  const canvasWidth = getCanvasWidth(orientation);

  return (
    <>
      <Box className="section-bottombar-wrapper" style={{ '--canvas-width': `${canvasWidth}px` } as React.CSSProperties}>
        <SectionToolbarAddMenu sectionId={sectionId} />
      </Box>
    </>
  );
}
